import { useAppDispatch, useAppSelector } from "@/config/store";
import { EdoStudentState, getStudent } from "@/shared/reducers/entities/edo-student.reducer";
import { Card } from "@/components/ui";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import NewCourseMaterials from "./components/NewCourseMaterials/NewCourseMaterials";
import QuizAttempts from "./components/QuizAttempts/QuizAttempts";
import TimingChart from "./components/TimingChart";

const ChildDetail = () => {
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();

  const {
    entity: { entity: student },
  } = useAppSelector<EdoStudentState>((state) => state.edoStudent);

  useEffect(() => {
    if (params.id) dispatch(getStudent(params.id));
  }, [params.id, dispatch]);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div className="col-span-full">
        <Card className="surface overflow-hidden rounded-3xl p-0">
          <div className="flex flex-row items-center px-4 py-3">
            <div>
              <h2 className="text-heading mb-1 font-semibold text-[var(--color-mockup-text)]">
                {student?.user?.firstName + " " + student?.user?.lastName}
              </h2>
              <p className="text-body text-[var(--color-mockup-text-mid)]">
                {student?.user?.email}
              </p>
            </div>
          </div>
        </Card>
      </div>
      <div>
        <QuizAttempts student={student} />
      </div>
      <div>
        <NewCourseMaterials student={student} />
      </div>
      <div className="col-span-full">
        <TimingChart student={student} />
      </div>
    </div>
  );
};

export default ChildDetail;
